import React, { Fragment, useCallback, useState } from 'react'
import { styled } from '@mui/system'
import { alpha } from '@mui/material/styles'
import ActionDelete from '@mui/icons-material/Delete'
import { Button, useNotify, useRedirect, useTranslate, useRefresh } from 'react-admin'

import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button as ButtonMaterial,
} from '@mui/material'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'

export const DeleteButtonWithValidationRule = ({ resource, record, name, genderElement, label }) => {
  const refresh = useRefresh()
  const translate = useTranslate()
  const notify = useNotify()
  const [validationData, setValidationData] = useState(null)

  const handleDelete = useCallback(
    async (e) => {
      e.stopPropagation()
      const data = await businessRuleServices.deleteFormulaGlobalVariable(record.id)
      if (Array.isArray(data) && data.length > 0) {
        setValidationData(data)
      } else {
        notify(`ra.notification.deleted_success_${genderElement}`, {
          type: 'success',
          messageArgs: { element: translate(`ra.single_entity.${resource}`) },
        })
        refresh()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [resource, record, genderElement]
  )

  const handleModalClose = (e) => {
    e.stopPropagation()
    setValidationData(null)
  }

  return (
    <Fragment>
      <StyledButton
        className='ra-delete-button'
        onClick={handleDelete}
        label={label}
        startIcon={<ActionDelete />}
      />
      {validationData && <ValidationModal varName={name} data={validationData} onClose={handleModalClose} />}
    </Fragment>
  )
}

const StyledButton = styled(Button, {
  name: 'RaDeleteWithConfirmButton',
  overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
  color: theme.palette.error.main,
  '&:hover': {
    backgroundColor: alpha(theme.palette.error.main, 0.12),
    // Reset on mouse devices
    '@media (hover: none)': {
      backgroundColor: 'transparent',
    },
  },
}))

const ValidationModal = ({ varName, data, onClose }) => {
  const redirect = useRedirect()
  const translate = useTranslate()

  return (
    <Modal open={true} onClose={onClose} disableBackdropClick disableEscapeKeyDown>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minHeight: 400,
          minWidth: 400,
          height: 'auto',
          width: '60%',
          bgcolor: 'background.paper',
          border: '2px solid #000',
          borderRadius: '10px',
          boxShadow: 24,
          p: 4,
          overflowY: 'auto',
          maxHeight: '90vh',
        }}
      >
        <Typography variant='h6' component='h2'>
          {translate('ra.message.error_to_delete_formula_global_variables', { name: varName })}
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item) => (
              <TableRow key={item.id}>
                <TableCell>{item.id}</TableCell>
                <TableCell>{item.name}</TableCell>
                <TableCell>
                  <ButtonMaterial
                    onClick={(e) => {
                      e.stopPropagation()
                      window.open(`/#/business-rule/${item.id}`, '_blank')
                    }}
                    color='primary'
                    variant='contained'
                    sx={{ mt: 2 }}
                  >
                    {translate('ra.action.edit')}
                  </ButtonMaterial>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <ButtonMaterial onClick={onClose} color='primary' variant='contained' sx={{ mt: 2 }}>
          {translate('ra.action.close')}
        </ButtonMaterial>
      </Box>
    </Modal>
  )
}
